import BaseViewModel from './BaseViewModel';

// Модель выбранного пользователя для свойства ContactInfo
class UserInfoListViewModel extends BaseViewModel {
	typeId = 'UserInfoList';
	// Имя выбранного участника для сохранения ContactInfo
	UserName = '';

	// Value содержит только хэш, даже при загрузке ContactInfo
	setValue = (value: unknown) => {
		if (typeof value === 'string') {
			this.Value = value;
			this.UserName = '';
			return;
		}

		const contactInfo =
			typeof value === 'object' && value !== null ? value : null;
		this.Value =
			contactInfo &&
			'CredentialHash' in contactInfo &&
			typeof contactInfo.CredentialHash === 'string'
				? contactInfo.CredentialHash
				: undefined;
		this.UserName =
			contactInfo &&
			'UserName' in contactInfo &&
			typeof contactInfo.UserName === 'string'
				? contactInfo.UserName
				: '';
	};

	// Возвращаем строковый хэш, которым заполняет Value
	getCredentialHash = (): string => {
		return typeof this.Value === 'string' ? this.Value : '';
	};

	// Имя берём из выбора пользователя или загруженного ContactInfo
	getUserName = (): string => {
		return this.UserName;
	};

	// Не пропускаем заданный хэш, пока пользователь по нему не определён
	runValidation = (): boolean => {
		const isResolved = !this.getCredentialHash() || !!this.UserName.trim();
		if (!isResolved) {
			this.errorMessage =
				'Дождитесь загрузки пользователя или выберите его заново';
		}
		return isResolved;
	};
}

export default UserInfoListViewModel;
